import React from "react"
import { TM } from "../components/common/typography/trademark"

export const columnItems = [
  {
    heading: "User Guides",
    textArray: [
      {
        link: (
          <>
            IronCAP X<TM /> (FREE Personal Usage)
          </>
        ),
        url:
          "https://www.01com.com/01com/ironcap-x/webhelp/index.htm#t=IronCAP_X%2FWelcome_to_IronCap_X.htm",
      },
      {
        link: (
          <>
            IronCAP X<TM /> (Business Usage)
          </>
        ),
        url:
          "https://www.01com.com/01com/ironcap-x/webhelp/index.htm#t=IronCAP_X%2FWelcome_to_IronCap_X.htm",
      },
      {
        link: (
          <>
            IronCAP X<TM /> Tutorial
          </>
        ),
        url: "https://www.youtube.com/watch?v=iKSD8MYShsY",
      },
    ],
  },
  {
    heading: "Downloads",
    textArray: [
      {
        link: (
          <>
            IronCAP X<TM /> (FREE Personal Usage)
          </>
        ),
        url: "https://ironcap.ca/ironcap-x/personal",
      },
      {
        link: (
          <>
            IronCAP X<TM />
            (Business Usage)
          </>
        ),
        url: "https://ironcap.ca/ironcap-x/personal",
      },
      {
        link: (
          <>
            IronCAP
            <TM /> Co-Branding Guideline
          </>
        ),
        url: "https://www.01com.com/pdf/ironcap-co-branding-guideline.pdf",
      },
    ],
  },
  {
    heading: "FAQs",
    textArray: [
      {
        link: (
          <>
            IronCAP X<TM />
          </>
        ),
        url: "/ironcap-x/faq",
      },
      {
        link: (
          <>
            IronCAP
            <TM /> Key (coming soon)
          </>
        ),
        url: "#",
      },
      {
        link: (
          <>
            IronCAP
            <TM /> Toolkits
          </>
        ),
        url: "/ironcap-toolkits/faq",
      },
    ],
  },
]
